var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.woringtext != 'none')?_c('div',{staticClass:"woring"},[_vm._v(" "+_vm._s(_vm.woringtext))]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }